export const DISTRIBUTION_TYPES = ["Anonymous Teaser", "Identifiable Deal Information", "Full Deal Pack", "Other"];
export const IDENTIFIABLE_TYPES = ["Identifiable Deal Information", "Full Deal Pack"];
export const DIST_CHANNELS = ["Email", "WhatsApp", "Phone", "In Person", "Other"];
export const DIST_RESPONSES = ["No Response", "Interested", "Wants Viewing", "Wants More Information", "Offer Considered", "Proceeding", "Declined"];

export const matchBadge = (c) => ({ "Strong Match": "bg-emerald-100 text-emerald-800", "Possible Match": "bg-amber-100 text-amber-800", "Outside Criteria": "bg-slate-200 text-slate-600" }[c] || "bg-white/10 text-emerald-100/70");
export const respBadge = (r) => {
  if (r === "Proceeding") return "bg-emerald-100 text-emerald-800";
  if (r === "Declined") return "bg-red-100 text-red-700";
  if (r === "No Response" || !r || r === "Not Sent") return "bg-white/10 text-emerald-100/60";
  return "bg-blue-100 text-blue-800";
};
export const reasonIcon = (s) => (s === "yes" ? { c: "text-emerald-300", m: "✓" } : s === "no" ? { c: "text-red-300", m: "✗" } : { c: "text-amber-300", m: "?" });
export const gbp = (v) => (v || v === 0) && !isNaN(v) ? "£" + Number(v).toLocaleString("en-GB", { maximumFractionDigits: 0 }) : "—";
export const pct = (v) => (v || v === 0) && !isNaN(v) ? Number(v).toFixed(2) + "%" : "—";
export const dt = (d) => d ? new Date(d).toLocaleDateString("en-GB") : "—";
